module.exports = __webpack_public_path__ + "static/img/编组.8d16e77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/编组.png
// module id = CGAe
// module chunks = 1